import { Controller } from '@hotwired/stimulus';
import Platform from '../../helpers/platform';

export default class extends Controller {
  static targets = [
    'messageItem',
    'conversation',
    'conversationSkeleton',
    'conversationContainer',
    'sidebar',
    'emptyConversationContainer',
    'mediaTab',
    'chatWrapper',
    'messageForm',
    'chatBackButton',
    'backButton',
    'galleryButton',
  ];
  static classes = ['highlighted'];

  connect() {
    this.removeUnreadCount();
    this.focusInput();

    // if no conversation is rendered, reset sidebar items, no highlighted item
    if (!this.hasConversationContainerTarget) {
      this.resetSidebarItems();
    }
  }

  conversationContainerTargetConnected() {
    // highlight current conversation in sidebar based on rendered conversation
    this.resetSidebarItems();

    let messageItem = document.querySelector(`#sidebar-conversation-${this.conversationContainerTarget.dataset.conversationId} .sidebar-conversation-item`);
    if (messageItem) {
      this.highlightMenuItem(messageItem);
    }

    this.focusInput();

    // when we have conversation we hide skeleton and show conversation container
    if (this.hasConversationSkeletonTarget) {
      this.conversationSkeletonTarget.classList.add('hidden');
    }

    if (this.hasConversationContainerTarget) {
      this.conversationContainerTarget.classList.remove('hidden');
    }
  }

  focusInput() {
    const messageInput = this.element.querySelector('#message_body');
    if (messageInput && !Platform.isMobileDevice()) {
      messageInput.focus();
    }
  }

  removeUnreadCount() {
    this.handleFrameLoad = (event) => {
      if (event.target.id === 'conversation') {
        const conversationId = this.conversationContainerTarget.getAttribute(
          'data-conversation-id'
        );
        if (conversationId) {
          const sidebarItem = document.querySelector(
            `#sidebar-conversation-${conversationId}`
          );
          if (sidebarItem) {
            sidebarItem
              .querySelector(`#unread-count-${conversationId}`)
              ?.remove();
          }
        }
      }
    };
    document.addEventListener('turbo:frame-load', this.handleFrameLoad);
  }

  selectMessage(event) {
    if (this.hasConversationSkeletonTarget) {
      this.conversationSkeletonTarget.classList.remove('hidden');
      if (this.hasConversationContainerTarget) {
        this.conversationContainerTarget.classList.add('hidden');
      }
      if (this.hasEmptyConversationContainerTarget) {
        this.emptyConversationContainerTarget.classList.add('hidden');
      }
    }
    this.resetSidebarItems();

    if (Platform.useMobileNavigation() && this.hasSidebarTarget) {
      this.sidebarTarget.classList.add('hidden');
    }

    if (Platform.useMobileNavigation() && this.hasConversationTarget) {
      this.conversationTarget.classList.remove('hidden');
    }

    this.highlightMenuItem(event.currentTarget);
  }

  toggleGalleryTab() {
    this.mediaTabTarget.classList.toggle('hidden');
    this.chatWrapperTarget.classList.toggle('hidden');
    this.chatBackButtonTarget.classList.toggle('hidden');
    this.messageFormTarget.classList.toggle('hidden');
    this.galleryButtonTarget.classList.toggle('hidden');
    this.backButtonTarget.classList.toggle('hidden');
  }

  disconnect() {
    document.removeEventListener('turbo:frame-load', this.handleFrameLoad);
  }

  resetSidebarItems() {
    this.messageItemTargets.forEach((item) => {
      item.classList.remove(this.highlightedClass);
      item.classList.add('hover:bg-gray-50');
    });
  }

  highlightMenuItem(item) {
    item.classList.add(this.highlightedClass);
    item.classList.remove('hover:bg-gray-50');
  }
}
